import React, { useEffect, useContext } from 'react'
import { AcademyContext } from '../../../../Context/AcademyContext/AcademyContext'
import { SelCon } from './styles'
import { GeneralSelect } from '../../../../Components/Layout/Selectors/General/GeneralSelect'
import { Reset } from '../../../../Components/Buttons/styles'

type SelRowParams = {
  onStateChange: (val: string) => void
  onMonthChange: (val: string) => void
  onTrainingChange: (val: string) => void
}

export const SelectorsRow: React.FC<SelRowParams> = ({
  onStateChange,
  onMonthChange,
  onTrainingChange,
}) => {
  const {
    stateList,
    stateSelect,
    monthList,
    monthSelect,
    trainingList,
    trainingSelect,
    handleReset,
  } = useContext(AcademyContext)!

  useEffect(() => {}, [stateList])

  return (
    <SelCon>
      <GeneralSelect
        current={monthSelect}
        defaultVal="By Month"
        list={monthList}
        onSelectChange={onMonthChange}
        size="md"
      />
      <GeneralSelect
        current={stateSelect}
        defaultVal="All States"
        list={stateList}
        onSelectChange={onStateChange}
        size="md"
      />
      <GeneralSelect
        current={trainingSelect}
        defaultVal="All Training"
        list={trainingList}
        onSelectChange={onTrainingChange}
        size="md"
      />
      <Reset onClick={handleReset}>Reset</Reset>
    </SelCon>
  )
}
